export default {
    "feedback":{
        "text" : "",
        "title" : "Send feedback to the Sinequa admin",
        "content" : {
            "text" : "Content",
            "title" : "Propose to add new content or improve the current content"
        },
        "ui" : {
            "text" : "User Interface",
            "title" : "Propose improvements to the User Interface"
        },
        "lang" : {
            "text" : "Language",
            "title" : "Propose language processing improvements, like new words, synonyms to add to the dictionaries (this affects directly the relevance of the search engine)"
        },
        "other" : {
            "text" : "Other",
            "title" : "Submit feature requests, and other improvement ideas"
        },
        "thankyou": "Thank you for your feedback!",
        "quality" : {
            "label" : "Quality of the document:"
        },
        "relevance" : {
            "label" : "Relevance of the document:"
        },
        "labels" : {
            "public" : {
                "label" : "Tags:"
            },
            "private" : {
                "label" : "Private tags:"
            }
        }
    }
};
